import React from 'react';

export const SkeletonLoader = ({ count = 3, type = 'row' }) => {
  if (type === 'row') {
    return (
      <div className="skeleton-container">
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="skeleton-row skeleton-row--medal">
            <div className="skeleton skeleton-text skeleton-medal-rank" />
            <div className="skeleton-medal-country">
              <div className="skeleton skeleton-flag" />
              <div className="skeleton skeleton-text skeleton-medal-country-text" />
            </div>
            <div className="skeleton skeleton-text skeleton-medal-value" />
            <div className="skeleton skeleton-text skeleton-medal-value" />
            <div className="skeleton skeleton-text skeleton-medal-value" />
            <div className="skeleton skeleton-text skeleton-medal-value" />
          </div>
        ))}
      </div>
    );
  }

  if (type === 'card') {
    return (
      <div className="skeleton-container">
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="skeleton-card">
            <div className="skeleton skeleton-title" />
            <div className="skeleton skeleton-text" />
            <div className="skeleton skeleton-text" style={{ width: '80%' }} />
          </div>
        ))}
      </div>
    );
  }

  return null;
};
